module.exports = __webpack_public_path__ + "static/person-writing-on-notebook-4144923-d5920849d4673431b8b6ac1dbffbfec6.jpg";